<template>
  <b-nav-item-dropdown right no-caret alt="Notifications" title="Notifications">
    <template slot="button-content">
      <span class="button-text pr-1">
        <i class="fa fa-bell fa-lg"></i>
        <span v-show="!isLoading" class="notification-badge">{{ unreadCount }}</span>
      </span>
    </template>
    <b-dropdown-item variant="dark" v-if="isMercureToken">
      Notifications are currently unavailable, please Logout and Login again.
    </b-dropdown-item>
    <div v-else>
      <b-dropdown-item variant="dark" v-if="unreadCount === 0">
        No unread notifications... You are all caught up!
      </b-dropdown-item>
      <b-dropdown-item v-for="notification in lastTenNotifications" :key="notification.id"
                       @click="openNotification(notification)"
                       variant="dark">
        {{ notification.title }}
      </b-dropdown-item>
      <div v-if="unreadCount !== 0">
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item class="view-all-center">
          <b-btn size="sm" block variant="primary" :to="{ name: 'UserNotifications' }">View All Notifications</b-btn>
        </b-dropdown-item>
      </div>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {mapGetters} from 'vuex'

export default ({
  name: "NavNotifications",
  computed: {
    ...mapGetters({
      isLoading: 'user/notifications/isLoading',
      unreadCount: 'user/notifications/unreadCount',
      lastTenNotifications: 'user/notifications/lastTenNotifications',
      isMercureToken: 'user/auth/isMercureToken',
    }),
  },
  methods: {
    openNotification(notification) {
      // Notification is opened
      switch (notification.type) {
        case 'project_resource':
          this.$router.push({name: 'ProjectResources', params: {id: notification.projectUrl}})
          break;
        case 'project_observation':
          this.$router.push({name: 'ObservationShow', params: {id: notification.typeIdentifier}})
          break;
        case 'project_forum_post':
        case 'project_forum_reply':
          this.$router.push({
            name: 'ProjectForumDiscussion',
            params: {id: notification.projectUrl, post: notification.typeIdentifier,}
          })
          break;
      }
    },
  },
})
</script>

<style scoped lang="scss">
.notification-badge {
  position: relative;
  color: #ffffff;
  border-radius: 50%;
}

.view-all-center {
  text-align: center;
}

.view-all-link {
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  top: 3px;
  transition: all .5s;
  width: 20px
}
</style>
